/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { bool, node } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(() => ({
    closeButton: {
        right: 29,
        top: 23,
        float: 'right',
        cursor: 'pointer',
        border: '1px solid #2F2F2F',
        width: '32px',
        height: '32px',
        padding: '0px',
        '@media only screen and (max-width:600px)': {
            top: '17px',
            right: '5px',
            width: '26px',
            height: '26px',
        },
        '@media only screen and (max-width:768px)': {
            zIndex: 1,
        },
        '& svg': {
            padding: '0 5px',
        },
        '&:hover': {
            backgroundColor: '#ffffff',
        },
    },
    addonDialog: {
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
}));
const AddonDialog = ({ addonContainer, closeDialog, isByoProduct }) => {
    const classes = useStyles();
    return (
        <div className={classes.addonDialog}>
            {!isByoProduct && (
                <IconButton data-testid="close-button" onClick={closeDialog} className={classes.closeButton} aria-label="close">
                    <CloseIcon />
                </IconButton>
            )}
            {addonContainer()}
        </div>
    );
};
AddonDialog.propTypes = {
    closeDialog: node,
    addonContainer: node,
    isByoProduct: bool,
};
AddonDialog.defaultProps = {
    addonContainer: () => null,
    closeDialog: () => null,
    isByoProduct: false,
};
export default AddonDialog;
